import useSupportStore from "../../../store/supportStore";
import { formatDateT } from "../../../../../shared/utils/formatters";
import { formatData } from "../../../utils/supportFormatters";

const stepKey = "spRegistration";

const SpRegistrationMapper = {
  get: () => {
    const store = useSupportStore.getState();
    return store[stepKey] || {};
  },
  set: (data) => {
    const store = useSupportStore.getState();
    const mappedStepData = { ...data };
    delete mappedStepData.pendingVehicleRegis;
    store.updateStepFields(stepKey, mappedStepData);

    const details = {
      "What is your new registration number?": data.prevVehicleRegis?.toUpperCase(),
      "Have the DVLA been notified of the change of registration? If no, you must notify the DVLA.":
        data.dvlaNotified,
      "Has the licencing authority been notified of the change of registration? If no, you must notify the licencing authority.":
        data.licAuthNotified,
      "Will your vehicle continue to be licenced by the existing licencing authority disclosed on your policy?":
        data.exitingLicenseAuth,
      ...(data.exitingLicenseAuth === "No" && {
        "New Licensing Authority": data.LicenseAuth?.label,
      }),
    };

    const currentChanges = store.Payload.Changes;
    store.updateField("Changes", {
      ...currentChanges,
      Registration: {
        Details: details,
        effectiveFrom: formatDateT(data.registrationEffectiveDateTime) || "",
        Requested: true,
      },
    });
  },
};

export default SpRegistrationMapper;
